import Loader from '../Loader';

const SuspenseFallback = () => (
  <div className='w-screen h-screen bg-black flex flex-col items-center justify-center'>
    <Loader />
  </div>
);

export default SuspenseFallback;
